// --------------------------------------------------------
// APPOINTMENT ATTENDANCE - AppointmentAttendance
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import { HdrAutoOutlined } from '@mui/icons-material'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { ReactComponent as Triagem } from '../../assets/imgs/triagemIcon.svg'
import { ReactComponent as CheckPositive } from '../../assets/imgs/checkPositive.svg'
import { ReactComponent as CalendarCheck } from '../../assets/imgs/calendarCheck.svg'
import { AppointmentStatus, getDescricaoByCodigoAppointmentStatus, getDescricaoByCodigoFormat } from '../../enums/AppointmentStatus';
import { Text } from '../UI/generalLayout/Layout.styled';
import Colors from '../../constants/Colors';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import moment from 'moment';
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// APPOINTMENT ATTENDANCE INTERFACE
// --------------------------------------------------------

interface IAppointmentAttendance {
  status: string;
  onChangeStatus: any;
  selectedDate: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
const AppointmentAttendance = ({
  status,
  onChangeStatus,
  selectedDate,
}: IAppointmentAttendance) => {
  // --------------------------------------------------------
  // APPOINTMENT ATTENDANCE PRIVATE DECLARATIONS
  // --------------------------------------------------------
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo();


  const today = moment().format('YYYY-MM-DD')
  const isPreviousDate = selectedDate.isBefore(today);
  const isToday = selectedDate.format('YYYY-MM-DD') === today
  const isRealizado = status !== null? status.toUpperCase() === AppointmentStatus.V.toUpperCase() : false;

  const onClickAppointmentStatus = (status: string | null) => {
    if (!isRealizado) {
      if (isToday) {
        onChangeStatus(status)
      } else if (isPreviousDate) {
        if (status === AppointmentStatus.X) {
          onChangeStatus(status)
        }
      }
    }
  }

  const getStatusColor = (status: string) => {
    switch (status.toUpperCase()) {
      case AppointmentStatus.T.toUpperCase():
        return "#DBA846";
      case AppointmentStatus.A.toUpperCase():
        return Colors.SPM300;
      case AppointmentStatus.X.toUpperCase():
        return "#D05952";
      case AppointmentStatus.EC.toUpperCase():
        return "#D05952";
      case AppointmentStatus.EA.toUpperCase():
        return "#0C65B4";
      case AppointmentStatus.ET.toUpperCase():
        return "#D1853E";
      case AppointmentStatus.V.toUpperCase():
        return "#81BD47";
      default:
        return "";
    }
  };

  const StatusIcon = ({ status, onClick }: any) => {
    switch (status.toUpperCase()) {
      case AppointmentStatus.T.toUpperCase():
      case AppointmentStatus.ET.toUpperCase():
        return (
          <Triagem
            onClick={onClick}
            stroke="white"
            color="white"
            width={40}
            height={20}
            style={{
              cursor: "pointer",
              marginTop: isMobile ? 10 : 20,
              marginRight: 10,
            }}
          />
        );
      case AppointmentStatus.A.toUpperCase():
      case AppointmentStatus.EA.toUpperCase():
        return (
          <HdrAutoOutlined
            onClick={onClick}
            style={{
              marginTop: isMobile ? 10 : 20,
              marginRight: 10,
              color: "white",
              cursor: "pointer",
            }}
          />
        );
      case AppointmentStatus.X.toUpperCase():
        return (
          <HighlightOffIcon
            onClick={onClick}
            style={{
              marginTop: 10,
              marginRight: 10,
              color: "white",
              cursor: "pointer",
            }}
          />
        );
      case AppointmentStatus.V.toUpperCase():
        return (
          <CheckPositive
            onClick={onClick}
            stroke="white"
            style={{
              marginTop: 10,
              marginRight: 10,
              color: "white",
              cursor: "pointer",
            }}
          />
        );
      default:
        return <></>;
    }
  };
  // --------------------------------------------------------
  // REACT RETURN FUNCTION
  // --------------------------------------------------------
  return (
    <>
      {status === null || status === AppointmentStatus.C ? (
        <div
          style={{
            padding: "0px 16px",
            borderRadius: 8,
            alignItems: "center",
            backgroundColor: "#EDEDED",
            width: isMobile ? "92%" : 120,
            height: 50,
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Triagem
            stroke="#C3C3C3"
            onClick={() => {
              onClickAppointmentStatus(AppointmentStatus.T);
            }}
            style={{ color: "#C3C3C3", cursor: "pointer" }}
          />
          <HdrAutoOutlined
            onClick={() => {
              onClickAppointmentStatus(AppointmentStatus.A);
            }}
            style={{ color: "#C3C3C3", cursor: "pointer" }}
          />
          <HighlightOffIcon
            onClick={() => {
              onClickAppointmentStatus(AppointmentStatus.X);
            }}
            style={{ color: "#C3C3C3", cursor: "pointer" }}
          />
        </div>
      ): (
        <div
          style={{
            padding: "0px 16px",
            borderRadius: 8,
            alignItems: "center",
            backgroundColor: getStatusColor(status),
            width: isMobile ? "92%" : 120,
            height: 50,
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ flexDirection: "row", display: "flex" }}>
            <StatusIcon
              onClick={() => {
                onClickAppointmentStatus(null);
              }}
              status={status}
            />
            <Text style={{ fontSize: 14, color: "white", cursor: "default" }}>
              {getDescricaoByCodigoAppointmentStatus(status)}
            </Text>
          </div>
        </div>
      )}
    </>
  );
  // --------------------------------------------------------
};

export default AppointmentAttendance;
